import SiteContext from "../context/SiteContext";
import {useContext, useEffect, useRef, useState} from "react";
const IndustryChatDemoMessage = ({message, industry, messageIndex, isGhost}) => {

    const {
        currentMessageIndex,
        updateCurrentMessageIndex,
        updateCurrentMessageSent,
        bastTypingSpeed,
    } = useContext(SiteContext);

    const [typedText, setTypedText] = useState("");
    const index = useRef(0);
    const typingStarted = useRef(false);
    const [showing, setShowing] = useState(false);
    const [showRef, setShowRef] = useState(false);

    const scrollToBottom = (callback) => {
        const scroller = document.querySelector('.chat-window-scroller')
        if(scroller){
            scroller.scrollTop = scroller.scrollHeight;
            if(callback)callback();
        }
    };


    useEffect(() => {

        let preDelayTimer = null;
        let typingTimer = null;
        let postDelayTimer = null

        const addClassTimer = setTimeout(() => {
            setShowing(true);
        }, 10);

        if (messageIndex === currentMessageIndex) {

            if(message.user === "bast"){
                preDelayTimer = setTimeout(() => {
                    typingStarted.current = true;
                    if(index.current < message.text.length){
                        if(isGhost){
                            setTypedText(message.text);
                        }else{
                            typingTimer = setTimeout(() => {
                                setTypedText(typedText + message.text[index.current])
                                index.current++
                            }, Number(bastTypingSpeed));
                        }

                    }else{
                        if(!message.ref) {
                            postDelayTimer = setTimeout(() => {
                                updateCurrentMessageIndex()
                            }, 750);
                        }else{
                            setShowRef(true);
                            setTimeout(() => {scrollToBottom(() => {updateCurrentMessageIndex()})}, 250);

                        }

                    }
                }, typingStarted.current?0:100);

            }else{
                setTypedText(message.text);
                preDelayTimer = setTimeout(() => {
                    postDelayTimer = setTimeout(() => {
                        updateCurrentMessageIndex()
                    }, 750);
                }, 250);
            }

        }
        return () => {
            clearTimeout(typingTimer);
            clearTimeout(postDelayTimer);
            clearTimeout(preDelayTimer);
            clearTimeout(addClassTimer);
        };
    }, [currentMessageIndex, isGhost, messageIndex, updateCurrentMessageIndex, typedText, message, index, updateCurrentMessageSent, showRef, setShowRef, bastTypingSpeed, message.text]);





    return (
        <div className={`chat-window-message 
        ${isGhost?'chat-window-message--ghost':''}
        ${message.user !== 'bast'?'chat-window-message--user':'chat-window-message-avatar--bast'} 
        ${showing?'sent':''} ${messageIndex === currentMessageIndex?'pulse':''}`}>
            {message.user === 'bast' ?
                <img alt="bast_avatar" className="chat-window-message-avatar" src={require(`../img/bast_chat_avatar.png`)} />
                :
                <img alt={`${industry.id}_avatar`} className="chat-window-message-avatar chat-window-message-avatar--user" src={industry.user_avatar}/>
            }
            <div>
                <span className="chat-window-message-text">
                    {typedText}
                </span>
                {
                    showRef && <img alt="reference_image" className={`chat-window-message-reference ${showRef?'show-ref':''}`} src={message.ref.img}/>
                }
            </div>


        </div>


    );
};

export default IndustryChatDemoMessage;
